import {AppBar, Box, Dialog, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {selectProject} from "../../redux/selectors/editor";
import {connect} from "react-redux";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {IVersion} from "../projects/Versions";
import {selectProjects} from "../../redux/selectors/firebase";
import {Projects} from "../../redux/types/firebase";

interface IAboutDialog {
    onClose: () => void
    open: boolean
    project: string
    projects: Projects
}
function AboutDialog({onClose, open, project, projects}: IAboutDialog) {
    const [dataVersion, setDataVersion] = useState<string>();
    const {last} = useContext(FirebaseContext);

    useEffect(() => {
        if (project && dataVersion === undefined) {
            last(`versions/${project}/import`, 1).then(snapshot => {
                const version = Object.values(snapshot as {[key: string]: IVersion} ?? {}).pop();

                setDataVersion(version ? `${version.version} ${version.tag}` : "Unknown");
            });
        }
    }, [dataVersion, last, project]);
    return (
        <Dialog onClose={onClose} open={open}>
            <AppBar position="relative">
                <Typography variant="h4" sx={{margin: 1}}>Pathway</Typography>
            </AppBar>
            <Box m={2} width={300}>
                <Box display="flex">
                    <Typography sx={{flexGrow: 1}}>Version:</Typography>
                    <Typography>{process.env.REACT_APP_VERSION}</Typography>
                </Box>
                <Box display="flex">
                    <Typography sx={{flexGrow: 1}}>Deployment:</Typography>
                    <Typography>{process.env.REACT_APP_MODE}</Typography>
                </Box>
                {project &&
                    <Box display="flex">
                        <Typography sx={{flexGrow: 1}}>Project:</Typography>
                        <Typography>{projects[project].name}</Typography>
                    </Box>
                }
                {dataVersion &&
                    <Box display="flex">
                        <Typography sx={{flexGrow: 1}}>Data:</Typography>
                        <Typography>{dataVersion}</Typography>
                    </Box>
                }
            </Box>
        </Dialog>
    )
}
const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    projects: selectProjects(store)
});

export default connect(mapStateToProps, {
})(AboutDialog);
